import { render, staticRenderFns } from "./InfoTransferContract.vue?vue&type=template&id=4f831307"
import script from "./InfoTransferContract.vue?vue&type=script&lang=js"
export * from "./InfoTransferContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports